export default __webpack_public_path__ + "static/media/Egis-blanc-vert.db0816f8.png";